// extracted by mini-css-extract-plugin
module.exports = {"mains":"View4_mains__2Z5l2","user":"View4_user__3K9bR"};